// src/components/constants/Layout.js

import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useMsal } from "@azure/msal-react";
import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { gapi } from 'gapi-script';

export const Layout = () => {
  const navigate = useNavigate();
  const { user,setUser } = useUser();
  console.log("USER   ",user)
  const { instance } = useMsal();

  const name = user?.name || "Unknown";
  console.log("N ",name)

  const initials = name
  ?.split(" ")
  .map((n) => n[0]) 
  .filter((char) => /^[A-Za-z]$/.test(char)) 
  .join("") 
  .toUpperCase(); 


  const [isSignOutVisible, setIsSignOutVisible] = useState(false);

  const toggleSignOut = () => {
    setIsSignOutVisible(!isSignOutVisible);
  };


  const handleSignOut = () => {
    console.log("SIGN ",user)
    if (user?.signInType === "microsoftsso") {
      setUser({});
      localStorage.clear();
      sessionStorage.clear();
      instance.logoutRedirect();
    } else if (user?.signInType === "googlesso") {
      setUser({});
      console.log("CLEAR")
      localStorage.clear();
      sessionStorage.clear();
      // localStorage.removeItem("https://accounts.google.com"); 
      navigate('/')
     
    }else if (user?.signInType === "basicauth") {
      setUser({});
      console.log("Signing out for Email authentication...");
      localStorage.clear();
      sessionStorage.clear();
      navigate('/')
    }
    else{
      setUser({});
      console.log("Signing out for Email authentication...");
      localStorage.clear();
      sessionStorage.clear();
      navigate('/')
    }
   
  };

  return (
    <div className="flex h-screen">
      {/* <Sidebar /> */}
      <main className="flex-1 p-3 relative bg-[#ebeff3]">
        <Header
          user_name={name}
          initials={initials}
          toggleSignOut={toggleSignOut}
          isSignOutVisible={isSignOutVisible}
          handleSignOut={handleSignOut}
        />
        <Outlet />
        <p className="absolute bottom-10 right-10 text-[13px] font-[600]">Powered by <a href="https://www.rcktechiees.com/us/services/enterprise-software-solutions/freshworks-services" target="_blank" className="text-[#007bff] hover:text[#006699] hover:underline cursor-pointer">RCK TECHIEES</a> </p>

        
      </main>
    </div>
  );
};
